// UI strings for sign-in, roles, admin, version history and conflicts.
// Merged into STR in i18n.jsx.
export const TEAM_STR = {
  // -- sign-in / first-run setup --------------------------------------------
  signInTitle: { th: "เข้าสู่ระบบ", en: "Sign in" },
  signInSubtitle: { th: "ใช้บัญชีที่ผู้ดูแลระบบสร้างให้ หรือบัญชี Google ของบริษัท", en: "Use the account your admin created, or your company Google account" },
  emailLabel: { th: "อีเมล", en: "Email" },
  passwordLabel: { th: "รหัสผ่าน", en: "Password" },
  signInBtn: { th: "เข้าสู่ระบบ", en: "Sign in" },
  signingIn: { th: "กำลังเข้าสู่ระบบ…", en: "Signing in…" },
  signInWithGoogle: { th: "เข้าสู่ระบบด้วย Google", en: "Sign in with Google" },
  orDivider: { th: "หรือ", en: "or" },
  authErr_bad_credentials: { th: "อีเมลหรือรหัสผ่านไม่ถูกต้อง", en: "Email or password is not correct" },
  authErr_not_allowed: { th: "บัญชี Google นี้ยังไม่ได้รับอนุญาต — ติดต่อผู้ดูแลระบบ", en: "This Google account isn't allowed — ask an admin" },
  authErr_disabled: { th: "บัญชีนี้ถูกระงับการใช้งาน — ติดต่อผู้ดูแลระบบ", en: "This account is disabled — ask an admin" },
  authErr_cancelled: { th: "ยกเลิกการเข้าสู่ระบบด้วย Google แล้ว", en: "Google sign-in was cancelled" },
  authErr_email_not_verified: { th: "อีเมลของบัญชี Google นี้ยังไม่ได้ยืนยัน", en: "That Google account's email isn't verified" },
  authErr_generic: { th: "เข้าสู่ระบบไม่สำเร็จ ลองอีกครั้ง", en: "Sign-in failed — try again" },
  sessionExpired: { th: "หมดเวลาการใช้งาน หรือสิทธิ์ของคุณถูกเปลี่ยน — กรุณาเข้าสู่ระบบอีกครั้ง", en: "Your session ended or your access changed — please sign in again" },
  setupTitle: { th: "ตั้งค่าครั้งแรก", en: "First-time setup" },
  setupDesc: { th: "สร้างบัญชีผู้ดูแลระบบคนแรก หลังจากนั้นผู้ดูแลระบบจะเพิ่มคนอื่นและกำหนดบทบาทได้ในหน้า \"ผู้ดูแลระบบ\"", en: "Create the first admin account. After that, admins add everyone else and set their roles on the Admin page." },
  nameLabel: { th: "ชื่อที่แสดง", en: "Display name" },
  confirmPasswordLabel: { th: "ยืนยันรหัสผ่าน", en: "Confirm password" },
  passwordHint: { th: "อย่างน้อย 10 ตัวอักษร", en: "At least 10 characters" },
  setupCodeLabel: { th: "รหัสตั้งค่า (SETUP_TOKEN)", en: "Setup code (SETUP_TOKEN)" },
  setupCodeHint: { th: "ค่า SETUP_TOKEN ที่ตั้งไว้ หรือถ้าไม่ได้ตั้ง ให้ดูรหัสที่เซิร์ฟเวอร์แสดงใน log ตอนเริ่มทำงาน", en: "Your SETUP_TOKEN value — or, if none is set, the code the server prints in its log when it starts" },
  createAdminBtn: { th: "สร้างผู้ดูแลระบบ", en: "Create admin" },
  passwordsDontMatch: { th: "รหัสผ่านทั้งสองช่องไม่ตรงกัน", en: "Passwords don't match" },
  // -- self sign-up + remember me --------------------------------------------
  authTabsLabel: { th: "เลือกเข้าสู่ระบบหรือสมัครสมาชิก", en: "Sign in or sign up" },
  signUpTab: { th: "สมัครสมาชิก", en: "Sign up" },
  signInSubtitleSignup: { th: "ใช้บัญชีของคุณ — ยังไม่มีบัญชี? กด \"สมัครสมาชิก\"", en: "Use your account — no account yet? Choose Sign up" },
  signUpTitle: { th: "สมัครสมาชิก", en: "Sign up" },
  signUpSubtitle: { th: "สมัครด้วยอีเมลบริษัท แล้วรอผู้ดูแลระบบอนุมัติและกำหนดสิทธิ์ให้", en: "Sign up with your company email, then wait for an admin to approve you and set your role" },
  signUpEmailHint: { th: "เฉพาะอีเมล {domains}", en: "Only {domains} emails" },
  signUpBtn: { th: "ส่งคำขอสมัคร", en: "Request account" },
  signingUp: { th: "กำลังส่งคำขอ…", en: "Sending…" },
  signUpDone: { th: "ส่งคำขอสมัครแล้ว — เข้าสู่ระบบได้เมื่อผู้ดูแลระบบอนุมัติ", en: "Request sent — you can sign in once an admin approves it" },
  rememberMe: { th: "จดจำฉันไว้ (ไม่ต้องเข้าสู่ระบบใหม่ {days} วัน)", en: "Remember me (stay signed in for {days} days)" },
  authErr_pending_approval: { th: "บัญชีของคุณกำลังรอผู้ดูแลระบบอนุมัติ", en: "Your account is waiting for an admin to approve it" },
  authErr_signup_domain: { th: "สมัครได้เฉพาะอีเมลบริษัท", en: "Only company emails can sign up" },
  authErr_signup_closed: { th: "ปิดรับสมัครอยู่ — ติดต่อผู้ดูแลระบบ", en: "Sign-up is closed — ask an admin" },
  authErr_email_taken: { th: "อีเมลนี้มีบัญชีอยู่แล้ว — ลองเข้าสู่ระบบ", en: "This email already has an account — try signing in" },
  authErr_bad_email: { th: "รูปแบบอีเมลไม่ถูกต้อง", en: "Enter a valid email address" },
  authErr_weak_password: { th: "รหัสผ่านต้องมีอย่างน้อย 10 ตัวอักษร", en: "Password must be at least 10 characters" },

  // -- account menu --------------------------------------------------------------
  signOut: { th: "ออกจากระบบ", en: "Sign out" },
  signOutAllDevices: { th: "ออกจากระบบทุกเครื่องของฉัน", en: "Sign out on all my devices" },
  changePassword: { th: "เปลี่ยนรหัสผ่าน", en: "Change password" },
  currentPassword: { th: "รหัสผ่านปัจจุบัน", en: "Current password" },
  newPassword: { th: "รหัสผ่านใหม่", en: "New password" },
  passwordChanged: { th: "เปลี่ยนรหัสผ่านแล้ว", en: "Password changed" },
  textSize: { th: "ขนาดตัวอักษร", en: "Text size" },
  accountMenu: { th: "เมนูบัญชี", en: "Account menu" },
  readOnlyBanner: { th: "บทบาทของคุณดูได้อย่างเดียว — ติดต่อผู้ดูแลระบบหากต้องการแก้ไข", en: "Your role is view-only — ask an admin if you need to edit" },

  // -- roles ------------------------------------------------------------------------
  role_admin: { th: "ผู้ดูแลระบบ", en: "Admin" },
  role_producer: { th: "โปรดิวเซอร์", en: "Producer" },
  role_onground: { th: "ทีม On-Ground", en: "On-Ground" },
  role_broadcast: { th: "ทีม Broadcast", en: "Broadcast" },
  role_viewer: { th: "ดูอย่างเดียว", en: "Viewer" },
  roleDesc_admin: { th: "ทุกอย่าง + จัดการผู้ใช้ ตั้งค่า และดูประวัติการใช้งาน", en: "Everything, plus users, settings and the activity log" },
  roleDesc_producer: { th: "แก้รันดาวน์ได้ทั้งหมด คุมโหมดถ่ายทอดสด นำเข้าตารางชก กู้คืนเวอร์ชัน", en: "Edit the whole rundown, run live control, import fight cards, restore versions" },
  roleDesc_onground: { th: "แก้ได้เฉพาะคอลัมน์ ON-GROUND", en: "Edit the ON-GROUND column only" },
  roleDesc_broadcast: { th: "แก้ได้เฉพาะคอลัมน์ BROADCAST และ platform", en: "Edit the BROADCAST and platform columns only" },
  roleDesc_viewer: { th: "ดูได้อย่างเดียว แก้ไม่ได้", en: "View only" },

  // -- admin ----------------------------------------------------------------------------
  userRole: { th: "บทบาท", en: "Role" },
  save: { th: "บันทึก", en: "Save" },
  navAdmin: { th: "ผู้ดูแลระบบ", en: "Admin" },
  adminUsers: { th: "ผู้ใช้และบทบาท", en: "People & roles" },
  adminAudit: { th: "ประวัติการใช้งาน", en: "Activity log" },
  adminSettings: { th: "ตั้งค่า", en: "Settings" },
  addUser: { th: "เพิ่มผู้ใช้", en: "Add person" },
  initialPassword: { th: "รหัสผ่านเริ่มต้น", en: "Initial password" },
  initialPasswordHint: { th: "เว้นว่างได้ถ้าคนนี้จะเข้าด้วย Google ของบริษัท", en: "Leave empty if they'll sign in with company Google" },
  create: { th: "สร้าง", en: "Create" },
  statusActive: { th: "ใช้งานอยู่", en: "Active" },
  statusDisabled: { th: "ถูกระงับ", en: "Disabled" },
  disableUser: { th: "ระงับ", en: "Disable" },
  enableUser: { th: "เปิดใช้", en: "Enable" },
  statusPending: { th: "รออนุมัติ", en: "Waiting for approval" },
  approveUser: { th: "อนุมัติ", en: "Approve" },
  pendingCount: { th: "มีคนรออนุมัติ {n} คน — เลือกบทบาทแล้วกด \"อนุมัติ\"", en: "{n} waiting for approval — pick a role, then Approve" },
  resetPassword: { th: "ตั้งรหัสผ่านใหม่", en: "Set password" },
  signOutEverywhere: { th: "ให้ออกจากระบบทุกเครื่อง", en: "Sign out everywhere" },
  lastLogin: { th: "เข้าใช้ล่าสุด", en: "Last sign-in" },
  never: { th: "ยังไม่เคย", en: "Never" },
  methodPassword: { th: "รหัสผ่าน", en: "Password" },
  methodGoogle: { th: "Google", en: "Google" },
  you: { th: "(คุณ)", en: "(you)" },
  done: { th: "เรียบร้อย", en: "Done" },
  auditWhen: { th: "เวลา", en: "When" },
  auditWho: { th: "ใคร", en: "Who" },
  auditWhat: { th: "ทำอะไร", en: "What" },
  auditItem: { th: "รายการ", en: "Item" },
  auditAllCollections: { th: "ทุกประเภท", en: "All types" },
  auditAllPeople: { th: "ทุกคน", en: "Everyone" },
  loadMore: { th: "โหลดเพิ่ม", en: "Load more" },
  auditEmpty: { th: "ยังไม่มีรายการ", en: "Nothing yet" },
  system: { th: "ระบบ", en: "System" },
  act_create: { th: "สร้าง", en: "Created" },
  act_set: { th: "แก้ไข", en: "Edited" },
  act_update: { th: "แก้ไข", en: "Edited" },
  act_delete: { th: "ลบ", en: "Deleted" },
  act_restore: { th: "กู้คืนเวอร์ชัน", en: "Restored version" },
  "act_auth.login": { th: "เข้าสู่ระบบ", en: "Signed in" },
  "act_auth.login_failed": { th: "เข้าสู่ระบบไม่สำเร็จ", en: "Failed sign-in" },
  "act_auth.setup": { th: "ตั้งค่าครั้งแรก", en: "First-time setup" },
  "act_user.update": { th: "แก้ข้อมูลผู้ใช้", en: "Updated person" },
  col_boards: { th: "รันดาวน์รายวัน", en: "Day rundown" },
  col_masters: { th: "Master รายวัน", en: "Weekday master" },
  col_templates: { th: "Template", en: "Template" },
  col_photoLibrary: { th: "คลังรูปภาพ", en: "Photo library" },
  col_settings: { th: "ตั้งค่า", en: "Settings" },
  col__users: { th: "ผู้ใช้", en: "People" },
  fieldsChanged: { th: "ส่วนที่แก้", en: "Changed" },
  settingsBranding: { th: "ชื่อที่แสดง", en: "Names shown" },
  venueNameTh: { th: "ชื่อสถานที่ (ไทย)", en: "Venue name (Thai)" },
  venueNameEn: { th: "ชื่อสถานที่ (อังกฤษ)", en: "Venue name (English)" },
  orgNameLabel: { th: "ชื่อองค์กร (แสดงหน้าเข้าสู่ระบบ)", en: "Organization (shown on sign-in)" },
  settingsWeekdays: { th: "รายการประจำแต่ละวัน", en: "Programme for each weekday" },
  wdName: { th: "ชื่อรายการ", en: "Programme name" },
  wdCategory: { th: "ประเภท", en: "Category" },
  wdCode: { th: "รหัส", en: "Code" },
  settingsStagePresets: { th: "เทมเพลตตำแหน่งเวที (Wai Kru / ระหว่างชก)", en: "Stage position templates (Wai Kru / during fight)" },
  stagePresetsHint: { th: "รูปแบบ JSON: { \"หมวด\": [ { \"pos\": \"P1\", \"waikruText\": \"…\", \"duringFightText\": \"…\" } ] }", en: "JSON: { \"category\": [ { \"pos\": \"P1\", \"waikruText\": \"…\", \"duringFightText\": \"…\" } ] }" },
  resetDefaults: { th: "คืนค่าเริ่มต้น", en: "Reset to defaults" },
  saveSettings: { th: "บันทึกการตั้งค่า", en: "Save settings" },
  settingsSaved: { th: "บันทึกการตั้งค่าแล้ว", en: "Settings saved" },
  invalidJson: { th: "รูปแบบ JSON ไม่ถูกต้อง", en: "That JSON isn't valid" },

  // -- version history ----------------------------------------------------------------------
  historyBtn: { th: "ประวัติเวอร์ชัน", en: "Version history" },
  historyTitle: { th: "ประวัติเวอร์ชัน", en: "Version history" },
  historyEmpty: { th: "ยังไม่มีเวอร์ชันก่อนหน้า", en: "No earlier versions yet" },
  historyEditedBy: { th: "แก้โดย", en: "Edited by" },
  historyReplacedBy: { th: "ถูกแทนที่โดย", en: "replaced by" },
  restoreBtn: { th: "กู้คืน", en: "Restore" },
  restoreConfirm: { th: "กู้คืนเวอร์ชันนี้? เวอร์ชันปัจจุบันจะยังถูกเก็บไว้ในประวัติ", en: "Restore this version? The current one stays in history." },
  restoredMsg: { th: "กู้คืนแล้ว", en: "Restored" },
  close: { th: "ปิด", en: "Close" },
  reason_delete: { th: "ก่อนถูกลบ", en: "before it was deleted" },

  // -- labels for icon-only buttons (read out by screen readers) ---------------------
  a11yAddBlock: { th: "เพิ่มบล็อกในแถวนี้", en: "Add a block on this row" },
  a11yPrevDay: { th: "วันก่อนหน้า", en: "Previous day" },
  a11yNextDay: { th: "วันถัดไป", en: "Next day" },
  a11yPrevMonth: { th: "เดือนก่อนหน้า", en: "Previous month" },
  a11yNextMonth: { th: "เดือนถัดไป", en: "Next month" },
  a11yPrevCue: { th: "คิวก่อนหน้า", en: "Previous cue" },
  a11yNextCue: { th: "คิวถัดไป", en: "Next cue" },
  a11yDate: { th: "วันที่", en: "Date" },
  a11yCueIcon: { th: "ไอคอน", en: "Icon" },
  skipToContent: { th: "ข้ามไปยังเนื้อหาหลัก", en: "Skip to main content" },

  // -- conflicts / errors --------------------------------------------------------------------
  conflictTitle: { th: "มีคนแก้ไขพร้อมกับคุณ", en: "Someone else edited this too" },
  conflictBody: { th: "{name} บันทึกการเปลี่ยนแปลงไว้เมื่อ {time} หลังจากที่คุณเปิดหน้านี้ การแก้ไขล่าสุดของคุณจึงยังไม่ถูกบันทึก", en: "{name} saved changes at {time}, after you opened this — so your latest edit hasn't been saved." },
  conflictReload: { th: "ใช้ฉบับล่าสุดของเขา", en: "Use their latest" },
  conflictOverwrite: { th: "บันทึกทับด้วยของฉัน", en: "Keep mine" },
  conflictHint: { th: "ไม่ว่าเลือกแบบไหน ฉบับที่ถูกแทนที่จะเก็บไว้ใน \"ประวัติเวอร์ชัน\"", en: "Either way, the version that gets replaced is kept in Version history" },
  someoneElse: { th: "อีกคน", en: "Someone else" },
  saveConflict: { th: "แก้ไขชนกัน", en: "Edit conflict" },
  forbiddenToast: { th: "บันทึกไม่ได้: บทบาทของคุณแก้ส่วนนี้ไม่ได้", en: "Not saved: your role can't change this" },
};
